import { Variavel } from '../variaveis/variavel';

export class Participante{
  id: number;
  nome: string;
  tipo_documento: string;
  numero_documento: string;
  email: string;
  variaveis: Variavel[];
  edicao: boolean = false;
  meus_certificados: any[];
  
}



// WEBPACK FOOTER //
// ./src/app/participantes/participante.ts